export default __webpack_public_path__ + "static/media/token.67f61038.png";